<template>

    <v-card class="mb-4 mx-2 d-flex flex-column justify-space-between" width="350" height="110"  style="position: relative">
        <v-skeleton-loader v-if="loading" type="card" style="position: absolute; width: 100%; height: 100%"/>
        <div class="px-3 pt-2 text-start body-1 font-weight-thin ">
            Activity Distribution
        </div>
        <div class="px-4 caption grey--text ">
            Activity distribution for today
        </div>

        <div v-if="!loading" style="width: 160px; position: absolute; top: 7px; right: -17px;" >
            <apex-chart type="radialBar" :options="chartOptions" :series="!stats ? [1,1,1,1] : series"></apex-chart>
        </div>

        <div  class="px-2 flex-grow-1 pb-1">
            <v-scroll-x-transition>
                <table v-if="!loading" style="table-layout: fixed ; width: 70%;">
                    <tr>
                        <td style="width: 100%">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="d-flex align-center caption justify-center" v-on="on">
                                        <v-icon :color="labelsRef[0].color" class="pr-1" small>{{ labelsRef[0].icon }}</v-icon>
                                        {{ !stats ? '00:00' : hourDisplay(stats.nt) }}
                                    </div>
                                </template>
                                {{ labelsRef[0].text }}
                            </v-tooltip>
                        </td>
                        <td style="width: 100%">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="d-flex align-center caption justify-center" v-on="on">
                                        <v-icon color="orange" class="pr-1" small>mdi-timer-sand-full</v-icon>
                                        {{ !stats ? '00:00' : hourDisplay(stats.it) }}
                                    </div>
                                </template>
                                Idle
                            </v-tooltip>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 100%">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="d-flex align-center caption justify-center" v-on="on">
                                        <v-icon :color="labelsRef[1].color" class="pr-1" small>{{ labelsRef[1].icon }}</v-icon>
                                        {{ !stats ? '00:00' : hourDisplay(stats.pt) }}
                                    </div>
                                </template>
                                {{ labelsRef[1].text }}
                            </v-tooltip>
                        </td>
                        <td style="width: 100%">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="d-flex align-center caption justify-center" v-on="on">
                                        <v-icon :color="labelsRef[2].color" class="pr-1" small>{{ labelsRef[2].icon }}</v-icon>
                                        {{ !stats ? '00:00' : hourDisplay(stats.ut) }}
                                    </div>
                                </template>
                                {{ labelsRef[2].text }}
                            </v-tooltip>
                        </td>
                    </tr>
                </table>
            </v-scroll-x-transition>
        </div>
    </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import VueApexCharts from 'vue-apexcharts'
import {hourDisplay, hourDisplayWithoutUnit} from "@/core/codeFunctions";
export default {
    components: {
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: {
                activeTime: 0,
                workTime: 0,
                nt: 0,
                pt: 0,
                ut: 0,
                it: 0
            },
            gradient: ["var(--v-primary-lighten1)", "var(--v-primary-darken2)"],
            refreshInterval: null,
            hourDisplayWithoutUnit,
            hourDisplay,
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        async loadProductivity() {
            try {
                this.stats = await this.$newReq('GET', 'dashboard/stats/activityDistribution')
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        ...mapGetters(['devicesWithAccess', 'devicesWithAccessIds', 'employeesRef', 'labelsRef']),
        labels() {return this.stats.map(stat => stat.key)},
        series() {

            let maxVal = [this.stats.nt, this.stats.it, this.stats.pt, this.stats.ut]
                    .reduce((max, val) => {
                        return val > max ? val : max
                    }, 0)

            return [
                Math.round(this.stats.it / maxVal * 100),
                Math.round(this.stats.pt / maxVal * 100),
                Math.round(this.stats.nt / maxVal * 100),
                Math.round(this.stats.ut / maxVal * 100),
            ]
        },



        chartOptions() {
            const colors = [
                `var(--v-orange-darken2)`,
                `var(--v-${this.labelsRef[1].color}-darken2)`,
                `var(--v-${this.labelsRef[0].color}-darken2)`,
                `var(--v-${this.labelsRef[2].color}-darken2)`,
            ];

            return {
                colors: colors,
                labels: [
                    this.labelsRef[0].text,
                    'Idle',
                    this.labelsRef[1].text,
                    this.labelsRef[2].text,
                ],
                plotOptions: {
                    fill: {
                        type: 'gradient',
                        colors: colors
                    },
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            show: false,
                            margin: 2,
                        },
                        hollow: {
                            margin: 0,
                            size: '30%',
                        },
                        dataLabels: {
                            enabled: false,
                            name: {show: false},
                            value: {show: false},
                        }
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: "horizontal",
                        shadeIntensity: 0.5,
                        gradientToColors: [
                            `var(--v-orange-lighten1)`,
                            `var(--v-${this.labelsRef[1].color}-lighten1)`,
                            `var(--v-${this.labelsRef[0].color}-lighten1)`,
                            `var(--v-${this.labelsRef[2].color}-lighten1)`,
                        ],
                        inverseColors: true,
                        stops: [0]
                    },
                },
                legend: {
                    show: false,
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: false,
                    curve: 'smooth',
                    lineCap: 'round',
                    colors: undefined,
                    width: 2,
                    dashArray: 0,
                },
                tooltip: {
                    enabled: false
                }
            }
        },


    }
}
</script>

<style scoped>

</style>